import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../panel/panel.jsx";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class CreateForm extends Component {
  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/productos/baja">Productos</Link>
          </li>
          <li className="breadcrumb-item active">Baja</li>
        </ol>
        <h1 className="page-header">Baja de producto</h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form
                  style={{ margin: "2%" }}
                  onSubmit={this.props.handleSubmit}
                >
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label htmlFor="establecimiento">
                          Establecimiento:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="establecimiento"
                          name="establecimiento"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleEstablecimientoChange}
                          theme="neutral40"
                          value={
                            this.props.state.establecimiento !== null
                              ? this.props.state.establecimiento
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_establecimiento}
                          getOptionLabel={(establecimiento) =>
                            establecimiento.razon_social
                              ? establecimiento.razon_social.toUpperCase()
                              : null
                          }
                          getOptionValue={(establecimiento) =>
                            establecimiento.id
                          }
                          noOptionsMessage={() =>
                            "No se encontraron establecimientos"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="establecimiento-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="actividad">
                          Actividad: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="actividad"
                          name="actividad"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleActividadChange}
                          theme="neutral40"
                          value={
                            this.props.state.actividad !== null
                              ? this.props.state.actividad
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_actividades}
                          getOptionLabel={(actividad) =>
                            actividad.descripcion
                              ? actividad.descripcion.toUpperCase()
                              : null
                          }
                          getOptionValue={(actividad) => actividad.id}
                          noOptionsMessage={() =>
                            "No se encontraron actividades"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="actividad-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label htmlFor="producto">
                          Producto: <span className="text-danger"> *</span>
                        </label>

                        <Select
                          id="producto"
                          name="producto"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleProductoChange}
                          theme="neutral40"
                          value={
                            this.props.state.producto !== null
                              ? this.props.state.producto
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_producto}
                          getOptionLabel={(producto) =>
                            producto.no_registro
                              ? `${producto.nombre_comercial} (${producto.no_registro})`
                              : producto.nombre_comercial
                          }
                          getOptionValue={(producto) => producto.id}
                          noOptionsMessage={() => "No se encontraron productos"}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="producto-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="prsentacion">
                          Presentación: <span className="text-danger"> *</span>
                        </label>

                        <Select
                          id="presentacion"
                          name="presentacion"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handlePresentacionChange}
                          theme="neutral40"
                          value={
                            this.props.state.presentacion !== null
                              ? this.props.state.presentacion
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_presentacion}
                          getOptionLabel={(presentacion) =>
                            presentacion.empaque_texto
                          }
                          getOptionValue={(presentacion) => presentacion.id}
                          noOptionsMessage={() =>
                            "No se encontraron presentaciones"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="presentacion-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-8">
                      <div className="form-group">
                        <label htmlFor="lote">
                          Lote: <span className="text-danger"> *</span>
                        </label>

                        <Select
                          id="num_lote"
                          name="num_lote"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleLoteChange}
                          theme="neutral40"
                          value={
                            this.props.state.num_lote !== null
                              ? this.props.state.num_lote
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_num_lote}
                          getOptionLabel={(lote) => lote.num_lote}
                          getOptionValue={(lote) => lote.id}
                          noOptionsMessage={() => "No se encontraron lotes"}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="num_lote-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="cantidad">
                          Cantidad: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="cantidad"
                          id="cantidad"
                          className="form-control"
                          placeholder="Ingrese cantidad"
                          value={this.props.state.cantidad}
                          onChange={this.props.handleCantidadChange}
                        />

                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="cantidad-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div
                      className={
                        this.props.state.motivo_baja.id === "3"
                          ? "col-lg-8"
                          : "col-lg-12"
                      }
                    >
                      <div className="form-group">
                        <label htmlFor="motivo_baja">
                          Motivo de baja:{" "}
                          <span className="text-danger"> *</span>
                        </label>

                        <Select
                          id="motivo_baja"
                          name="motivo_baja"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleMotivoBajaChange}
                          theme="neutral40"
                          value={
                            this.props.state.motivo_baja !== null
                              ? this.props.state.motivo_baja
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_motivo_baja}
                          getOptionLabel={(motivo_baja) =>
                            motivo_baja.descripcion
                          }
                          getOptionValue={(motivo_baja) => motivo_baja.id}
                          noOptionsMessage={() =>
                            "No se encontraron motivos de baja"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="motivo_baja-error"
                        ></div>
                      </div>
                    </div>
                    {this.props.state.motivo_baja.id === "3" ? (
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="motivo_baja">
                            País de exportación:{" "}
                            <span className="text-danger"> *</span>
                          </label>

                          <Select
                            id="pais_exportacion"
                            name="pais_exportacion"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            isClearable={false}
                            onChange={this.props.handlePaisChange}
                            theme="neutral40"
                            value={
                              this.props.state.pais_exportacion !== null
                                ? this.props.state.pais_exportacion
                                : { label: "Seleccione", key: "0" }
                            }
                            options={this.props.state.cat_paises}
                            getOptionLabel={(pais_exportacion) =>
                              pais_exportacion.descripcion
                            }
                            getOptionValue={(pais_exportacion) =>
                              pais_exportacion.id
                            }
                            noOptionsMessage={() => "No se encontraron paises"}
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="pais_exportacion-error"
                          ></div>
                        </div>
                      </div>
                    ) : null}
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="observacion">Observaciones:</label>
                        <textarea
                          id="observacion"
                          name="observacion"
                          value={this.props.state.observacion}
                          onChange={this.props.handleObservacionChange}
                          className="form-control"
                          placeholder="Ingrese observaciones"
                        ></textarea>
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="observacion-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <button className="btn btn-success btn-block">
                        Continuar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateForm;
